import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import DINRegular from "./DINNextLTPro-Regular.woff2";

export const ExcalifontFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: DINRegular,
    descriptors: {
      unicodeRange: "U+0020-10FFFF",
    },
  },
];
